import { Trash2, Plus } from 'lucide-react'
import { FC } from 'react'
import { useFieldArray, useFormContext } from 'react-hook-form'

import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'

import { FormData } from './'

const HeadersForm: FC = () => {
  const form = useFormContext<FormData>()

  const { fields, append, remove } = useFieldArray({
    control: form.control,
    name: 'headers',
  })

  return (
    <div className="space-y-4">
      {fields.length === 0 && (
        <p className="text-sm text-muted-foreground">
          No custom headers configured. <br /> Add headers like Authorization, Content-Type, etc.
        </p>
      )}

      {fields.map((field, index) => (
        <div key={field.id} className="space-y-2">
          <div className="grid grid-cols-2 gap-3">
            <div className="space-y-2">
              <Label htmlFor={`header-key-${index}`} className="text-xs font-medium text-muted-foreground">
                Header Name
              </Label>
              <Input
                id={`header-key-${index}`}
                {...form.register(`headers.${index}.key`)}
                placeholder="Authorization"
              />
            </div>
            <div className="space-y-2">
              <div className="flex items-center justify-between">
                <Label htmlFor={`header-value-${index}`} className="text-xs font-medium text-muted-foreground">
                  Header Value
                </Label>
                <Button
                  size="sm"
                  type="button"
                  variant="ghost"
                  onClick={() => remove(index)}
                  className="w-6 h-6 p-0 text-muted-foreground hover:text-destructive"
                >
                  <Trash2 className="w-3 h-3" />
                </Button>
              </div>
              <Input
                id={`header-value-${index}`}
                {...form.register(`headers.${index}.value`)}
                placeholder="Bearer token123"
              />
            </div>
          </div>
          {(form.formState.errors.headers?.[index]?.key || form.formState.errors.headers?.[index]?.value) && (
            <div className="space-y-1">
              {form.formState.errors.headers?.[index]?.key && (
                <p className="text-xs text-destructive">{form.formState.errors.headers[index].key.message}</p>
              )}
              {form.formState.errors.headers?.[index]?.value && (
                <p className="text-xs text-destructive">{form.formState.errors.headers[index].value.message}</p>
              )}
            </div>
          )}
        </div>
      ))}

      {fields.length < 3 && (
        <Button
          type="button"
          variant="outline"
          size="sm"
          onClick={() => append({ key: '', value: '' })}
          className="w-full"
        >
          <Plus className="w-4 h-4 mr-2" />
          Add Header
        </Button>
      )}
    </div>
  )
}

export default HeadersForm
